import pick from 'lodash-es/pick';
import { handleActions } from 'redux-actions';

import { SearchAreaValue } from 'ha/types/SearchFilters';

import { Actions } from '../constants';
import { MapViewState } from '../utils';

const initialState = {
  location: '',
  uniID: null,

  cityLocalized: '',
  countryLocalized: '',

  latitude: 0,
  longitude: 0,
  initialLatitude: 0,
  initialLongitude: 0,
  radius: 0,
  zoomLevel: null,
  bounds: undefined,

  isMobileMapOpen: false,

  mapViewState: MapViewState.noMap,
  visitedRooms: {},

  travelTime: {
    polygons: [],
    loading: false,
    currentInfo: null,
  },

  useMapAsAFilter: true,
};

export default handleActions(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      ...pick(payload, ['cityLocalized', 'countryLocalized', 'radius']),
      latitude: state.latitude ? state.latitude : payload.latitude,
      longitude: state.longitude ? state.longitude : payload.longitude,
      initialLatitude: payload.latitude,
      initialLongitude: payload.longitude,
    }),

    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      {
        payload: {
          location,
          uniID,
          view,
          openMap,
          searchArea,
          lLng,
          rLng,
          tLat,
          bLat,
        },
      },
    ) => ({
      ...state,
      location,
      uniID,
      ...(view &&
        view in MapViewState && {
          mapViewState: view,
        }),
      ...(openMap && {
        isMobileMapOpen: true,
      }),
      useMapAsAFilter: searchArea !== SearchAreaValue.CityBounds,
      ...(lLng &&
        rLng &&
        tLat &&
        bLat && {
          bounds: {
            leftLng: Number(lLng),
            rightLng: Number(rLng),
            topLat: Number(tLat),
            bottomLat: Number(bLat),
          },
        }),
    }),

    [Actions.UPDATE_MAP]: (
      state,
      { payload: { latitude, longitude, zoom } },
    ) => ({
      ...state,
      latitude,
      longitude,
      zoomLevel: zoom,
    }),

    [Actions.UPDATE_BOUNDS]: (state, { payload: { bounds } }) => ({
      ...state,
      bounds,
    }),

    [Actions.TOGGLE_MOBILE_MAP]: state => ({
      ...state,
      isMobileMapOpen: !state.isMobileMapOpen,
    }),

    [Actions.UPDATE_MAP_VIEW]: (state, { payload: value }) => ({
      ...state,
      mapViewState: value,
    }),

    [Actions.SET_VISITED_ROOMS]: (state, { payload: { visitedRooms } }) => ({
      ...state,
      visitedRooms,
    }),

    [Actions.RESET_MAP]: (state, { payload: { zoomLevel } }) => ({
      ...state,
      latitude: state.initialLatitude || initialState.latitude,
      longitude: state.initialLongitude || initialState.longitude,
      zoomLevel,
    }),

    [Actions.LOAD_POLYGON_START]: state => ({
      ...state,
      travelTime: {
        ...state.travelTime,
        loading: true,
        polygons: [],
      },
    }),
    [Actions.LOAD_POLYGON_ERROR]: state => ({
      ...state,
      travelTime: {
        ...state.travelTime,
        loading: false,
      },
    }),
    [Actions.LOAD_POLYGON_DONE]: (
      state,
      {
        payload: {
          polygons,
          placeId,
          placeCoordinates,
          travelMode,
          timeInSeconds,
          addressName,
        },
      },
    ) => ({
      ...state,
      travelTime: {
        polygons,
        loading: false,
        currentInfo: {
          placeId,
          placeCoordinates,
          travelMode,
          timeInSeconds,
          addressName,
        },
      },
    }),
    [Actions.CLEAR_POLYGON]: state => ({
      ...state,
      travelTime: {
        ...state.travelTime,
        polygons: [],
      },
    }),
  },
  initialState,
);
